import React from "react";
import { Link } from "react-router-dom";
import UpperFooterSlider from "../../Layout/Upper Footer Slider/UpperFooterSlider";

export default function SplitCanvases() {
  return (
    <div className="Gallery-Wraps-2 retouching Canvases">
      <main>
        {/* hera banner start */}
        <div
          className="tp-breadcrumb__area fix tp-breadcrumb-height"
          data-background="assets/img/breadcrumb/Canvases.png"
          style={{
            backgroundImage: 'url("assets/img/breadcrumb/Canvases.png")',
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="tp-breadcrumb__content text-center z-index-5">
                  <h3 className="tp-breadcrumb__title">
                    Split Canvases <br />
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* hero banner end */}
        {/* second content section start*/}
        <section className="parent">
          <section
            className=" pb-100 Partener photographs"
            data-background="assets/img/breadcrumb/routing.png"
            style={{backgroundImage:"url('assets/img/breadcrumb/routing.png')", backgroundSize: "cover" }}
          >
            <div className="container">
              <div className="row ">
                <div className="row text text-center pt-50">
                  <div className="col-xl-12 col-lg-12 col-md-12 text-center ">
                    <h4 className="text-left second">
                      Transforming your Image
                    </h4>
                    <p className="w-100">
                      That special place to make a statement. A special wall. In
                      the entry or the living room. Canvas Splits redefines your
                      art. Enhances the image to take on a spirit of its own.
                    </p>
                  </div>
                </div>
                <div
                  className="col-xl-8 col-lg-12 col-md-12 text-center m-auto pt-30"
                  style={{ zIndex: 9 }}
                >
                  <div className=" ">
                    <img
                      className="w-32"
                      src="assets/img/blog/LargeClassicTriptych 1.png"
                      alt=""
                    />
                  </div>
                </div>
                <div className="text-center mt-60 button-uper">
                  <Link className="  large head banner" >
                    Create split CANVASES
                  </Link>
                </div>
              </div>
            </div>
          </section>
        </section>
        {/* second content section end */}
        {/* wrapped section start */}
        <section className="pt-50 pb-80 Partener">
          <div className="container">
            <div className="row ">
              <div className="col-xl-5 col-lg-6 col-md-12 text sec">
                <div className="bottom-para left pt-30 pb-30 ">
                  <h4>How to hang Canvas Splits</h4>
                  <p>
                    Over your sofa or in the entry. Maybe you have a large wall
                    that is just screaming for a triptych. Create your space,
                    create your art.
                  </p>
                </div>
              </div>
              <div className="col-xl-7 col-lg-6 col-md-12">
                <div className=" ">
                  <img
                    className="w-32"
                    src="assets/img/blog/cavases-bottom.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* wraped section section end */}
        
        <UpperFooterSlider />
      </main>
    </div>
  );
}
